import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

@Component({
  imports: [MatDialogActions, MatButton, MatDivider, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './kids-buchung-faq.component.html',
  styleUrl: './kids-buchung-faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KidsBuchungFaqComponent {}
